module.exports = __webpack_public_path__ + "static/media/illustration-win.c62de587.svg";